import React from 'react';
import styled from 'styled-components';

import { convertThumbnailToPictureProps } from '@tager/web-modules';

import Picture from '@/components/Picture';
import Link from '@/components/Link';
import { colors } from '@/constants/theme';

import Category from './components/Category';
import { ArticleCardProps } from './types';

function ArticleCard({ image, title, url, category }: ArticleCardProps) {
  return (
    <Component>
      <Image>
        <StyledPicture
          loading="lazy"
          {...convertThumbnailToPictureProps(image)}
          alt={title}
        />
        <StyledLink to={url} />
        <Category {...category} />
      </Image>
      <Content>
        <ContentContainer>
          <Title to={url}>{title}</Title>
        </ContentContainer>
      </Content>
    </Component>
  );
}

export default ArticleCard;

const Component = styled.div`
  background: ${(props) => props.theme.white_1};
  border: 1px solid ${(props) => props.theme.gray1300};
  border-radius: 8px;
`;

const Image = styled.div`
  position: relative;
  padding-top: 75%;
`;

const StyledPicture = styled(Picture)`
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  picture {
    width: 100%;
    height: 100%;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const StyledLink = styled(Link)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`;

const Content = styled.div``;

const ContentContainer = styled.div`
  padding: 32px 20px 20px 20px;

  @media (min-width: 1400px) {
    padding: 50px 22px 39px 22px;
  }
`;

const Title = styled(Link)`
  font-weight: 700;
  font-size: 22px;
  line-height: 26px;
  color: ${(props) => props.theme.black100};
  transition: color 0.15s ease-in-out;

  &:hover {
    color: ${colors.main};
  }

  @media (min-width: 1400px) {
    font-size: 26px;
    line-height: 32px;
  }
`;
